import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';

export const ReportsTitleWrapper = styled.span``;

export const ReportsTitleAccent = styled.span`
  color: ${colors.GREEN};
`;
